import React, { forwardRef } from "react";

import { StyledLinearLoader } from "./Styles";

export interface LinearLoaderProps {
  height?: number;
  activeStrokeColor?: string;
  activeColorPercentage?: "25%" | "50%" | "75%";
  inactiveStrokeColor?: string;
  animationDuration?: number;
}

export const LinearLoader = forwardRef<HTMLDivElement, LinearLoaderProps>(
  (
    {
      height = 4,
      activeStrokeColor = "var(--color-secondary)",
      inactiveStrokeColor = "var(--color-theme-transparent-300)",
      activeColorPercentage = "25%",
      animationDuration = 0.75,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledLinearLoader
        ref={ref}
        $height={height}
        $activeStrokeColor={activeStrokeColor}
        $inactiveStrokeColor={inactiveStrokeColor}
        $activeColorPercentage={activeColorPercentage}
        $animationDuration={animationDuration}
        {...rest}
      />
    );
  }
);

LinearLoader.displayName = "LinearLoader";
